import TC from '../../TC';
import TabContainer from './TabContainer';
TC.control = TC.control || {};
TC.control.SelectContainer = TabContainer;
const SelectContainer = TC.control.SelectContainer;
export default SelectContainer;